import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m2.36 2.354q.243.355.492.759c.5.813 1.01 1.79 1.408 2.887h2.67a8.02 8.02 0 0 0-4.57-3.646m-1.212 1.805c.34.553.673 1.172.96 1.841H9.892a14.5 14.5 0 0 1 .961-1.84 16 16 0 0 1 1.148-1.636c.331.415.74.97 1.148 1.635M15 12c0-.685-.085-1.355-.231-2H9.23A9 9 0 0 0 9 12c0 .685.085 1.355.231 2h5.538A9 9 0 0 0 15 12m-.891 4H9.89c.288.669.621 1.288.961 1.84a16 16 0 0 0 1.148 1.636c.331-.415.74-.97 1.148-1.635.34-.553.673-1.172.96-1.841m-6.92-2C7.07 13.357 7 12.688 7 12s.07-1.357.19-2H4.251A8 8 0 0 0 4 12c0 .69.088 1.36.252 2zM5.07 16h2.67a16 16 0 0 0 1.408 2.887q.249.405.492.76A8.02 8.02 0 0 1 5.07 16m11.19 0h2.67a8.02 8.02 0 0 1-4.57 3.646q.243-.355.492-.759c.5-.813 1.01-1.79 1.408-2.887m3.488-2h-2.937c.12-.643.189-1.312.189-2s-.07-1.357-.19-2h2.938A8 8 0 0 1 20 12a8 8 0 0 1-.252 2m-10.6-8.887A16 16 0 0 0 7.74 8H5.07a8.02 8.02 0 0 1 4.57-3.646q-.243.355-.492.759",
      clipRule: "evenodd"
    }
  )
);
var SvgLanguageOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LanguageOutlined_default = SvgLanguageOutlined;

export { LanguageOutlined_default as default };
